<template>
  <v-app id="login">
    <v-main class="background-home">
      <v-container fluid fill-height class="text-center">
        <v-row>
          <v-col cols="12">
            <v-img :src="logo2" max-height="100" contain/>
          </v-col>
          <v-col cols="12">
            <v-card class="mx-auto" color="white" elevation="0" max-width="500">
              <v-card-title class="justify-center mb-3" style="color: #005591; font-size: 30px;">
                Plataforma de Asistencia Digital
              </v-card-title>
              <v-card-title class="justify-center l-subtitle mb-3">
                Inicio de sesión
              </v-card-title>
              <v-card-text>
                <v-form ref="formLogin" lazy-validation @keyup.enter.native="login()">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-model="form.email" label="Usuario" :rules="rules.email" :disabled="loading" outlined required autocomplete="off"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="form.password" type="password" label="Contraseña" :rules="rules.password" :disabled="loading" outlined required autocomplete="off"></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn large block color="primary" :disabled="form.email == '' || form.password == ''" :loading="loading" @click="login()">Entrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12">
            <a href="https://www.linde.mx/privacy-statement" style="text-decoration: none;">
              <p class="font-weight-black" style="font-size: 18px; color: #005591;">
                Aviso de privacidad
              </p>
            </a>
            <p class="font-weight-black" style="font-size: 15px; color: #005591;">
              Version {{version}}
            </p>
          </v-col>
        </v-row>
        <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
          {{ msgError }}
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'login',
  data: () => ({
    host: process.env.VUE_APP_API_SERVER,
    name: process.env.VUE_APP_NAME,
    version: process.env.VUE_APP_VERSION,
    path: '/pub/login',
    loading: false, 
    error: false,
    msgError: '',
    logo: require('@/assets/logo.png'),
    logo2: require('@/assets/logo_footer.svg'),
    form: {
      email: '',
      password: ''
    },
    rules: {
      email: [
        v => !!v || '',
        v => (v && v.length <= 255) || '',
      ],
      password: [
        v => !!v || '',
        v => (v && v.length <= 255) || ''
      ]
    }
  }),
  methods: {
    login() {
      if (this.$refs.formLogin.validate()) {
        this.loading = true
        let data = {
          username: this.form.email,
          password: this.form.password,
          dispositivo: {
            idunico: '',
            modelo: '',
            sistema_operativo: ''
          },
          token: ''
        }
        this.axios.post(this.host + this.path, { data })
          .then(response => {
            let res = response.data
            this.$session.start()
            this.$session.set('jwt', res.token)
            this.$router.push('/home')
          })
          .catch(error => {
            this.error = true
            if (error.response) {
              this.msgError = error.response.data.message
            }
            else {
              this.msgError = 'Servicio no disponible. Intente más tarde'
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
      else {
        this.error = true
        this.msgError = 'Los datos son incorrectos'
      }
    }
  }
}
</script>

<style scoped>
</style>
